import { z } from 'zod';
import { THEMES } from '../enums.js';
/**
 * `PATCH /api/me` — a staff member editing their own display name, theme
 * preference, and/or dashboard widget order. Deliberately has no `email`
 * field: email-change authority is a future role-based flow, not a
 * self-service one, so the field is absent here rather than
 * accepted-and-ignored.
 *
 * `dashboardLayout` is an opaque ordered list of widget ids — validated only
 * for shape here, never against a widget registry. The frontend already
 * tolerates unknown/missing ids (a widget added, removed, or renamed after a
 * layout was saved), so the server doesn't need to know the current set of
 * valid ids to accept an update.
 */
export const updateProfileSchema = z
    .object({
    name: z.string().trim().min(1).max(200).optional(),
    theme: z.enum(THEMES).optional(),
    dashboardLayout: z.array(z.string().min(1).max(60)).max(50).optional(),
})
    .refine((value) => value.name !== undefined || value.theme !== undefined || value.dashboardLayout !== undefined, { message: 'Nothing to update' });
//# sourceMappingURL=user.js.map